import React, { Component } from "react";
import { Button, Icon, Header, Modal, Segment, Grid } from "semantic-ui-react";
import ReactTable from "react-table";

import request from "../../utils/request";
import findKey from "lodash/findKey";
import matchSorter from 'match-sorter';

import Sellers from "../../components/forms/event/Sellers";
import CheckboxFilter from "../../components/forms/elements/CheckboxFilter";

class EventSellers extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.state = {
      isMounted: false,
      loading: true,
      eventId: this.props.match.params.id,
      data: [],
      pages: null,
      pollInterval: false,
      volunteer: [],
      sellerId: [],
      sellers: [],
      expanded: {},
      open: false
    };
  }
  show = () => this.setState({ open: true });
  close = () => this.setState({ open: false }, this.pollData);
  componentWillUnmount = () => {
    this._mounted = false;
    clearInterval(this.state.pollInterval);
  };
  startLoading = () => {
    this.setState({ loading: true });
  };
  doneLoading = () => {
    this.setState({ loading: false });
  };
  pollData = () => {
    let self = this;
    self.startLoading();
    let payload = {
      eventId: this.state.eventId,
      pageSize: this.state.pageSize,
      page: this.state.page,
      sorted: this.state.sorted,
      filtered: this.state.filtered,
      ts: Date.now()
    };
    return request
      .get(this, `api:/event-sellers/${this.state.eventId}`, payload)
      .then(resp => {
        if (!this._mounted) return false;
        self.setState({
          data: resp.data,
          pages: resp.pages,
        }, self.fetchSellers);
        return resp;
      })
      .then(event => {
        self.handlePoll(event);
        return true;
      });
  };
  handlePoll = resp => {
    if (!this._mounted) return false;
    if (!this.state.pollInterval) {
      let poll = setInterval(this.pollData, 15000);
      this.setState({
        pollInterval: poll
      });
    }
  };
  componentDidMount = () => {
    this._mounted = true;
    this.pollData();
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({
        data: [],
        pages: null,
        loading: true,
        eventId: this.props.eventId
      });
    }
  };
  fetchSellers = () => {
    this.startLoading();
    request.get(
      this,
      "api:/volunteer-real",
      {
        limit: 5000,
        sort: [{ id: "first_name", desc: true }, { id: "last_name", desc: true }]
      }
    ).then(resp => {
      let sellers = [];
      let data = this.state.data;
      resp && resp.data && resp.data.map((value) => {
        let key = findKey(data, { volunteer_id: +value.id });
          if (!key)
            return sellers.push({
              text: value.first_name + ' ' + value.last_name,
              value: parseInt(value.id)
            });
          else
            return false;
      });
      this.setState({ volunteer: sellers }, this.doneLoading);
      return true;
    });
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleAll = () => {
    const { volunteer } = this.state;
    let sellerIds = [];
    volunteer.map(v => {
      return sellerIds.push(v.value);
    });
    this.setState({ sellerId: sellerIds }, this.handleSubmit);
  }
  handleSubmit = e => {
    e && e.preventDefault();
    let { eventId } = this.props;
    let { sellerId } = this.state;
    let sellersParam = [];
    sellerId.map(value => {
      sellersParam.push({
        active: 1,
        value: value,
        location_id: 0,
        float: 0,
        notes: '',
        login: '',
      });
      return value;
    });
    request
      .post(this, `api:/event-sellers`, {
        sellers: sellersParam,
        eventId: eventId
      })
      .then(resp => {
        this.setState({
          xhrStatus: resp.status,
          xhrMessages: [resp.message],
          sellerId: []
        }, this.pollData);
      });
  };
  handleClean = () => {
    let { eventId } = this.props;
    request
      .put(this, `api:/event-sellers/${eventId}`, {
        eventId: eventId,
      })
      .then(resp => {
        this.setState({
          xhrStatus: resp.status,
          xhrMessages: [resp.message],
          sellerId: []
        }, this.pollData);
      });
  };
  handleSave = e => {
    this._child.handleData(e);
  };
  defaultSortMethod = (a, b, desc) => {
    // force null and undefined to the bottom
    a = a === null || a === undefined ? -Infinity : a
    b = b === null || b === undefined ? -Infinity : b
    // force any string values to lowercase
    a = typeof a === 'string' ? a.replace(/[^\d.]/g, '') : a
    b = typeof b === 'string' ? b.replace(/[^\d.]/g, '') : b
    // Return either 1 or -1 to indicate a sort priority
    if (Number(a) > Number(b)) {
      return 1
    }
    if (Number(a) < Number(b)) {
      return -1
    }
    // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
    return 0
  }
  render() {
    const columns = [
      {
        expander: true,
        Header: () => <strong>More</strong>,
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
          <div>
            {isExpanded ? (
              <Icon name="caret down" />
            ) : (
                <Icon name="caret right" />
              )}
          </div>
        ),
        style: {
          cursor: "pointer",
          fontSize: 25,
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      },
      {
        Header: "Name",
        id: "volunteer",
        accessor: "volunteer",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["volunteer"] }),
        filterAll: true
      },
      {
        Header: "Device",
        accessor: "unit_name",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["unit_name"] }),
        filterAll: true
      },
      {
        Header: "Location",
        accessor: "location",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["location"] }),
        filterAll: true
      },
      {
        Header: "Trans.",
        accessor: "quantities",
        filterable: false
      },
      {
        Header: "Reprints",
        accessor: "stats_reprint",
        filterable: false
      },
      {
        Header: "Cash",
        accessor: "salesamount_cash",
        filterable: false
      },
      {
        Header: "Credit",
        accessor: "salesamount_credit_card",
        filterable: false
      },
      {
        Header: "Total",
        accessor: "total",
        filterable: false
      },
      {
        Header: "Stored",
        accessor: "ticketscached",
        filterable: false
      },
      {
        Header: "Ping",
        accessor: "ping",
        filterable: false
      }
    ];
    const { data, pages, loading, tablePageSize, eventId, expanded, open } = this.state;
    return (
      <Segment basic>
        <Segment basic>
          <Grid>
            <Grid.Column floated='left' mobile={16} tablet={16} computer={6}>
              <CheckboxFilter
                name="sellerId"
                options={this.state.volunteer}
                value={this.state.sellerId}
                onChange={this.handleChange}
              />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={10}>
              <Grid columns={4} doubling>
                <Grid.Column>
                  <Button
                    fluid
                    type="button"
                    primary
                    onClick={this.handleSubmit}>
                    Assign Selected
                </Button>
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    type="button"
                    color='green'
                    onClick={this.handleAll}>
                    Assign All
                </Button>
                </Grid.Column>
                <Grid.Column>
                  <Modal trigger={<Button fluid type="button" color='black' onClick={this.show}>Manage Assigned</Button>} closeIcon onClose={this.close} open={open}>
                    <Header content="Manage Assigned" />
                    <Modal.Content scrolling>
                      <Sellers eventId={eventId} ref={component => this._child = component} />
                    </Modal.Content>
                    <Modal.Actions>
                      <Button onClick={this.close}>Close</Button>
                      <Button onClick={this.handleSave} primary>Save</Button>
                    </Modal.Actions>
                  </Modal>
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    type="button"
                    color='red'
                    onClick={this.handleClean}>
                    Remove Unused
                </Button>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </Segment>
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight eventSellerListTable"
          pages={pages} // Display the total number of pages
          loading={loading} // Display the loading overlay when we need it
          resizable={true}
          defaultSorted={[
            {
              id: "volunteer",
              desc: false
            }
          ]}
          filterable
          defaultPageSize={100}
          minRows={0}
          expanded={expanded}
          onExpandedChange={(expanded) => {
            this.setState({ expanded });
          }}
          getTrProps={(state, rowInfo, column) => {
            if (parseInt(rowInfo.row.ticketscached) > 0 && (rowInfo.row.ping === "Deactivated" || rowInfo.row.ping.indexOf('second') === -1)) {
              return { className: "-negative" };
            }
            if (parseInt(rowInfo.row.ticketscached) > 0 && (rowInfo.row.ping.indexOf('second') > -1)) {
              return { className: "-warning" };
            }
            return { className: "" }
          }}
          SubComponent={row => {
            const subcolumns = [
              {
                Header: "Price Point",
                id: "amount",
                accessor: d => d.quantity + " for $" + d.amount
              },
              {
                Header: "Count",
                accessor: "setCount"
              },
              {
                Header: "Total Tickets",
                accessor: "totalTickets"
              },
              {
                Header: "Total Cost",
                accessor: "totalCost"
              },
              {
                Header: "% of Sales",
                accessor: "salesPC"
              },
              {
                Header: "% of Tickets",
                accessor: "ticketsPC"
              }
            ];
            return (
              <div style={{ padding: "20px" }}>
                <ReactTable
                  data={row.original.salesBreakdown}
                  columns={subcolumns}
                  minRows={0}
                  resizable={false}
                  defaultPageSize={tablePageSize}
                  showPagination={false}
                  className="eventSellerTable"
                />
              </div>
            );
          }}
        />
      </Segment>
    );
  }
}

export default EventSellers;
